import playlistCustomers from 'maps/customer-name-id';
import { ICustomer } from 'redux/reducers/customers';

const getCustomerData = (
  customers: ICustomer[] | undefined,
  playlistCustomerId: string | number
): { customerId: string; customerName: string } => {
  const customerId =
    typeof playlistCustomerId === 'number'
      ? Object.keys(playlistCustomers).find(
          (key) => playlistCustomers[key] === playlistCustomerId
        )
      : playlistCustomerId.toLowerCase();

  const currentCustomer = customers?.filter(
    (customer: ICustomer) =>
      customer.name.toLowerCase() === customerId.toLowerCase() &&
      customer.feedType === 'streaming'
  );

  const customerName =
    (currentCustomer &&
      currentCustomer.length > 0 &&
      currentCustomer[0].displayName) ||
    '';

  return { customerId, customerName };
};

export default getCustomerData;
